<div>
  By the end of the program, students will be expected to:</div>

<app-plo-list *ngIf="programOutcomeCategories.length > 0 || programOutcomes.length > 0" [programOutcomeCategories]="programOutcomeCategories"
  [programOutcomes]="programOutcomes" (proceedEditOutcome)="editOutcome($event)" (proceedDeleteOutcome)="confirmDeleteOutcome($event)"
  (proceedEditCategory)="editCategory($event)" (proceedDeleteCategory)="confirmDeleteCategory($event)"></app-plo-list>